import axios from 'axios';
import { getApiBaseUrl } from '@/lib/apiUrl';

interface TestResultType {
  score: number;
}

interface StressLevelResponse {
  labels: string[];
  data: number[];
}

export const submitTestResult = async (
  testResult: TestResultType,
  token: string,
): Promise<void> => {
  await axios.post(`${getApiBaseUrl()}/stress-test`, testResult, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const fetchStressLevels = async (
  auth_user_id: string,
  token: string,
): Promise<StressLevelResponse> => {
  const response = await axios.get<StressLevelResponse>(
    `${getApiBaseUrl()}/stress-test/${auth_user_id}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
};
